export const USER_NAME_ERROR = 'The username is already taken';
export const EMAIL_ERROR = 'The email address is already taken';
export const INCORRECT_PASSWORD_ERROR = 'The password is invalid';
export const CURRENT_PASSWORD_ERROR = 'The current password is invalid';
export const FORGOT_PASSWORD_NO_USER_FOUND = 'No corresponding user was found';
